import SupportServices from './SupportServices';
import SupportServicesMock from './SupportServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? SupportServicesMock : SupportServices;
